export default __webpack_public_path__ + "static/media/photo--lg--team.775a079a.jpg";